<agr-summary-card
  [title]="'eipDeliveriesWidgetTitle' | translate"
  [subTitle]="'eipDeliveriesWidgetSubTitle' | translate"
  class="list-summary-card"
  [actions]="cardActions"
>
  @if (deliveries()?.length !== 2) {
    <agr-notification-empty [isEmpty]="true"></agr-notification-empty>
  }
  @if (deliveries()?.length === 2) {
    <dl class="spacing--margin-none-top spacing--margin-bottom">
      <dt class="text--label crop-year">{{ 'year' | translate }}</dt>
      <dd class="text--h4 crop-year">
        <div class="spacing--margin-bottom">{{ deliveries()?.[0]?.year }}</div>
        <div>{{ deliveries()?.[1]?.year }}</div>
      </dd>
      <dt class="text--label">{{ 'environmentalImpactPointsAquaticLife' | translate }}</dt>
      <dd class="text--h4">
        <div class="spacing--margin-bottom">{{ deliveries()?.[0]?.values?.waterLife | number: '1.0-0' }}</div>
        <div>{{ deliveries()?.[1]?.values?.waterLife | number: '1.0-0' }}</div>
      </dd>
      <dt class="text--label">{{ 'environmentalImpactPointsSoilLife' | translate }}</dt>
      <dd class="text--h4">
        <div class="spacing--margin-bottom">{{ deliveries()?.[0]?.values?.soilLife | number: '1.0-0' }}</div>
        <div>{{ deliveries()?.[1]?.values?.soilLife | number: '1.0-0' }}</div>
      </dd>
      <dt class="text--label">
        {{ 'environmentalImpactPointsGroundWaterWashout' | translate }}
      </dt>
      <dd class="text--h4">
        <div class="spacing--margin-bottom">{{ deliveries()?.[0]?.values?.groundwaterWashout | number: '1.0-0' }}</div>
        <div>{{ deliveries()?.[1]?.values?.groundwaterWashout | number: '1.0-0' }}</div>
      </dd>
    </dl>
    @if (dataSource(); as data) {
      @if (chartOptions(); as options) {
        <agr-chart [dataSource]="data" [options]="options"></agr-chart>
      }
    }
  }
</agr-summary-card>
